import { render, staticRenderFns } from "./ContentSpacer.vue?vue&type=template&id=4efb8e86&scoped=true&"
import script from "./ContentSpacer.vue?vue&type=script&lang=js&"
export * from "./ContentSpacer.vue?vue&type=script&lang=js&"
import style0 from "./ContentSpacer.vue?vue&type=style&index=0&id=4efb8e86&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4efb8e86",
  null
  
)

export default component.exports